import React from "react";
import { Link } from "react-router-dom";
import { CalendarDays, ArrowLeft, ShieldCheck } from "lucide-react";
import { NotificationBell } from "@/components/platform/NotificationBell";

function countdownClasses(days) {
  if (days == null) return "bg-slate-100 text-slate-600 border-slate-200";
  if (days > 365) return "bg-[#388E3C]/10 text-[#388E3C] border-[#388E3C]/30";
  if (days > 90) return "bg-[#FBC02D]/15 text-[#B8860B] border-[#FBC02D]/40";
  return "bg-[#D32F2F]/10 text-[#D32F2F] border-[#D32F2F]/30";
}

export const HeaderBar = ({ orgName, assessmentId, deadline, daysRemaining, schemaVersion }) => {
  const urgent = daysRemaining != null && daysRemaining <= 90;
  return (
    <header
      data-testid="grc-header-bar"
      className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-200"
    >
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 h-16 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <Link
            to="/dashboard"
            data-testid="header-back-link"
            className="text-slate-500 hover:text-[#008080] transition-colors shrink-0"
            aria-label="Back to assessments"
          >
            <ArrowLeft size={18} />
          </Link>
          <div className="flex items-center gap-2 shrink-0">
            <div className="w-8 h-8 rounded-lg bg-[#003366] flex items-center justify-center">
              <ShieldCheck size={16} className="text-white" />
            </div>
            <div className="leading-tight">
              <div className="text-sm font-bold text-[#003366]">
                GRC Dashboard{" "}
                {schemaVersion && (
                  <span className="text-[10px] font-mono font-medium px-1.5 py-0.5 rounded bg-slate-100 text-slate-500 align-middle">
                    {schemaVersion}
                  </span>
                )}
              </div>
              <div className="text-[11px] text-slate-500 truncate max-w-[220px]" data-testid="header-org-name">
                {orgName || assessmentId || "—"}
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
        <NotificationBell />
        <div
          data-testid="deadline-countdown-pill"
          className={`flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-semibold ${countdownClasses(daysRemaining)}`}
        >
          <CalendarDays size={14} />
          <span>
            {daysRemaining == null
              ? "Deadline —"
              : `${urgent ? "URGENT: " : ""}${daysRemaining} days remaining`}
          </span>
          {deadline && <span className="hidden sm:inline font-normal opacity-70">to {deadline}</span>}
        </div>
        </div>
      </div>
    </header>
  );
};
